import { getProjectInfo } from '../../store';
import { ICrestRopeSpecificationsRequest } from '../IApiRequest';
import BeMaccaferriProductsProvider from './BeMaccaferriProductsProvider';

const getCurrentProjectInfo = () => getProjectInfo().data;

const getCurrentLanguage = () => window.localStorage.getItem('i18nextLng') ?? 'en-US';

type ApiDecoratorOptions = {
    country?: boolean;
    unit?: boolean;
    lang?: boolean;
};


const apiDecorator = <T>(callback: (...args: any[]) => Promise<T>, options: ApiDecoratorOptions, fixedArgs: unknown[] = []) => {
    const projectInfo = getCurrentProjectInfo();
    const args = [...fixedArgs];

    if (options.country) {
        args.push(projectInfo?.productCountry ?? '');
    }
    if (options.unit) {
        args.push(projectInfo?.unit);
    }
    if (options.lang) {
        args.push(getCurrentLanguage());
    }

    return callback(...args);
};

export const getMeshTypes = async () => apiDecorator(BeMaccaferriProductsProvider.getMeshTypes, { country: true, unit: true, lang: true });

export const getRopesTypes = async () => apiDecorator(BeMaccaferriProductsProvider.getRopesTypes, { country: true, unit: true, lang: true });

export const getRopeSteels = async () => apiDecorator(BeMaccaferriProductsProvider.getRopeSteels, { unit: true, lang: true });

export const getRopeCores = async () => apiDecorator(BeMaccaferriProductsProvider.getRopeCores, { lang: true });

export const getAnchorTypes = async () => apiDecorator(BeMaccaferriProductsProvider.getAnchorTypes, { country: true, unit: true, lang: true });

export const getCrestRopeSpecification = async (requestData: ICrestRopeSpecificationsRequest) =>
    apiDecorator(BeMaccaferriProductsProvider.getCrestRopeSpecification, { unit: true, lang: true }, [requestData]);

export const getMacro1MeshTypes = async () => apiDecorator(BeMaccaferriProductsProvider.getMacro1MeshTypes, { country: true, unit: true, lang: true });

export const getMacro1AnchorTypes = async () => apiDecorator(BeMaccaferriProductsProvider.getMacro1AnchorTypes, { country: true, unit: true });

export const getLanguages = async () => BeMaccaferriProductsProvider.getLanguages();
